var exports = {};

function circIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

exports = circIn;
export default exports;